export enum AutomationContractType {
  AllTypes = 0,
}
